import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-style-background.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util  from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class StyleBackgroundView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');


        this.events = {
            'change #backgroundColorText, #styleBGColor2Text, #transparentBackground' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #backgroundColor, #styleBGColor2' : 'updateColorPicker'
        };

        this.bgColorProperty = 'backgroundColor';
        this.bgGradientColorProperty = 'bgGradientColor';

        if (this.columnModel.get('factoryKey') === 'fileAttachmentColumn') {
            this.bgColorProperty = 'buttonBackgroundColor';
            this.bgGradientColorProperty = 'buttonBackgroundGradientColor';
        }
        
        if (this.columnModel.attributes['factoryKey'] === 'checkboxColumn' || this.columnModel.attributes['factoryKey'] === 'radioButtonColumn'){
            this.columnModel.attributes['transparentBackground'] = util.isTrue(this.columnModel.attributes['transparentBackground']);
            this.columnModel.attributes['showGradient'] = false;
        }else{
            this.columnModel.attributes['transparentBackground'] = undefined;
            this.columnModel.attributes['showGradient'] = true;
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldPropVal;

        if (propName === 'transparentBackground'){
            propVal = ev.currentTarget.checked;
            this.columnModel.attributes[propName] = propVal;

            undoService.add({
                undo: () =>{
                    $('#' + propName).prop('checked', !propVal);
                    this.columnModel.attributes[propName] = !propVal;
                    this.render();
                },
                redo:() => {                    
                    $('#' + propName).prop('checked', !propVal);
                    this.columnModel.attributes[propName] = propVal;
                    this.render();
                }
            },textConstants.UNDO_PROP_CHANGE);
            this.render();
        }else {
            if (util.isValidColorcode(propVal)) {
                let color = this.resolveColor(propVal);
                $('#' + propName).val(color);

                if (propName === 'backgroundColor') {
                    oldPropVal = this.columnModel.attributes[this.bgColorProperty];
                    this.columnModel.attributes[this.bgColorProperty] = color;
                }
                if (propName === 'styleBGColor2') {
                    oldPropVal = this.columnModel.attributes[this.bgGradientColorProperty];
                    this.columnModel.attributes[this.bgGradientColorProperty] = color;
                }
                this.render();

                // PF-5745
                undoService.add({
                    undo: () =>{
                        let oldColor = this.resolveColor(oldPropVal);
                        $('#' + propName).val(oldColor);

                        if (propName === 'backgroundColor') {
                            this.columnModel.attributes[this.bgColorProperty] = oldColor;
                        }
                        if (propName === 'styleBGColor2') {
                            this.columnModel.attributes[this.bgGradientColorProperty] = oldColor;
                        }
                        this.render();
                    },
                    redo:() => {
                        let color = this.resolveColor(propVal);
                        $('#' + propName).val(color);

                        if (propName === 'backgroundColor') {
                            this.columnModel.attributes[this.bgColorProperty] = color;
                        }
                        if (propName === 'styleBGColor2') {
                            this.columnModel.attributes[this.bgGradientColorProperty] = color;
                        }
                        this.render();
                    }
                },textConstants.UNDO_PROP_CHANGE);
            } else {
                this.render();
            }
        }
    }

    updateColorPicker(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id;
        const propVal  = ev.currentTarget.value;
        let oldPropVal;

        var propTextName = propName + 'Text';
        $('#' + propTextName).val(propVal);

        if (propName === 'backgroundColor') {
            oldPropVal = this.columnModel.attributes[this.bgColorProperty];
            this.columnModel.attributes[this.bgColorProperty] = propVal;
        }
        if (propName === 'styleBGColor2') {
            oldPropVal = this.columnModel.attributes[this.bgGradientColorProperty];
            this.columnModel.attributes[this.bgGradientColorProperty] = propVal;
        }

        // PF-5745
        undoService.add({
            undo: () =>{
                var propTextName = propName + 'Text';
                $('#' + propTextName).val(oldPropVal);

                if (propName === 'backgroundColor') {
                    this.columnModel.attributes[this.bgColorProperty] = oldPropVal;
                } else if (propName === 'styleBGColor2') {
                    this.columnModel.attributes[this.bgGradientColorProperty] = oldPropVal;
                }
                this.render();
            },
            redo:() => {
                var propTextName = propName + 'Text';
                $('#' + propTextName).val(propVal);

                if (propName === 'backgroundColor') {
                    this.columnModel.attributes[this.bgColorProperty] = propVal;
                } else if (propName === 'styleBGColor2') {
                    this.columnModel.attributes[this.bgGradientColorProperty] = propVal;
                }
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);

    }

    getPropValues() {
        return _.merge(this.columnModel.toJSON(), {backgroundColor:  this.columnModel.attributes[this.bgColorProperty], backgroundGradientColor: this.columnModel.attributes[this.bgGradientColorProperty] });
    }

    render() {
        super.render();
        this.$el.empty();
        if(this.template) {
            const props = this.getPropValues();
            this.$el.html(this.template(props));
        }

        this.delegateEvents();
        return this;
    }

}

export default StyleBackgroundView;
